import { Code, File, TransformedFile } from './framesUtils.types';

export const getFramesListData = (
  codes: Code[] = [],
): {
  incFrameList: { frames: ({ mediaOwner: string; assetId: string } | string)[] }[];
  excFrameList: { frames: ({ mediaOwner: string; assetId: string } | string)[] }[];
} => {
  const formatFrameData = ({
    code,
    mediaOwner,
  }: {
    code: string;
    mediaOwner: string;
  }): { mediaOwner: string; assetId: string } | string => ({
    assetId: code,
    mediaOwner,
  });

  const incFrameList = codes
    .filter(({ include }) => include)
    .map(({ code, mediaOwner }) => formatFrameData({ code, mediaOwner }));

  const excFrameList = codes
    .filter(({ include }) => !include)
    .map(({ code, mediaOwner }) => formatFrameData({ code, mediaOwner }));

  return {
    incFrameList: incFrameList.length ? [{ frames: incFrameList }] : [],
    excFrameList: excFrameList.length ? [{ frames: excFrameList }] : [],
  };
};
const transformFile = ({ name, fileId, dynamoDbFileId }: File): TransformedFile => ({
  fileName: name,
  ...(fileId ? { fileId } : {}),
  ...(dynamoDbFileId ? { dynamoDbFileId } : {}),
});

export const getFramesFileData = (
  files: File[] = [],
): { incFileList: TransformedFile[]; excFileList: TransformedFile[] } => {
  const incFileList = files.filter(({ include }) => include).map(transformFile);
  const excFileList = files.filter(({ include }) => !include).map(transformFile);

  return {
    incFileList,
    excFileList,
  };
};

export const getUploadedFramesFileData = (
  files: File[],
): { incFileList: TransformedFile[]; excFileList: TransformedFile[] } => {
  const incFileList: TransformedFile[] = [];
  const excFileList: TransformedFile[] = [];

  files.forEach(({ name, dynamoDbFileId, fileId, include }) => {
    if (include) {
      incFileList.push({
        fileName: name,
        ...(dynamoDbFileId ? { dynamoDbFileId } : {}),
        ...(fileId ? { fileId } : {}),
      });
    } else {
      excFileList.push({
        fileName: name,
        ...(dynamoDbFileId ? { dynamoDbFileId } : {}),
        ...(fileId ? { fileId } : {}),
      });
    }
  });

  return {
    incFileList,
    excFileList,
  };
};

export const getVisualUnitsData = (
  visualUnitCodes: Code[],
  visualUnitFiles: File[],
): {
  includeVisualUnits?: (TransformedFile | { frames: ({ assetId: string; mediaOwner: string } | string)[] })[];
  excludeVisualUnits?: (TransformedFile | { frames: ({ assetId: string; mediaOwner: string } | string)[] })[];
} => {
  const { incFrameList, excFrameList } = getFramesListData(visualUnitCodes);
  const { incFileList, excFileList } = getUploadedFramesFileData(visualUnitFiles);

  const includeVisualUnits = [...incFrameList, ...incFileList];
  const excludeVisualUnits = [...excFrameList, ...excFileList];

  return {
    ...(includeVisualUnits.length ? { includeVisualUnits } : {}),
    ...(excludeVisualUnits.length ? { excludeVisualUnits } : {}),
  };
};

export const getVisualUnitData = (
  visualUnitCodes: Code[],
  visualUnitFiles: File[],
): ReturnType<typeof getVisualUnitsData> => getVisualUnitsData(visualUnitCodes, visualUnitFiles);
